
import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const createGeneralUser = createAsyncThunk("createGeneralUser", async ({ user_channel, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post("user/register", {
			...values,
			user_channel,
		});
		return response.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data || { message: error.message });
	}
});

export const resetStateGeneralUserCreateSlice = createAsyncThunk("resetStateGeneralUserCreateSlice", async () => {
	return true;
});

const GeneralUserCreateSlice = createSlice({
	name: "GeneralUserCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		isError: false,
	},

	extraReducers: (builder) => {
		builder.addCase(createGeneralUser.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(createGeneralUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			state.isError = false;
		});
		builder.addCase(createGeneralUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error;
			state.isError = true;
		});

		builder.addCase(resetStateGeneralUserCreateSlice.fulfilled, (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.isError = false;
		});
	},
});

export default GeneralUserCreateSlice.reducer;
